<template>
    <validation class="form-group" :class="{ hasError: hasErrors, hasSuccess: isValid }"  :validator="v" :name="name" :inputclass="inputclass">
        <label v-if="label != ''">{{label}}</label>
        <div v-if="data !== ''" class="position-relative">
            <a :href="data" target="_blank"><img :src="data" alt="" class="img-fluid" style="max-height: 88px" /></a>
            <span class="badge bg-danger-400 badge-pill badge-float border-2 border-white cursor-pointer" @click="deleteImage" ><i class="icon-cross3"></i></span>
        </div>
        <Upload v-if="data === ''"
            :max-size="2048"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :on-error="handleUploadError"
            :headers=getHeaders()
            name="file"
            type="drag"
            :action=getUploadPath() >
            <div style="padding: 10px 0px 30px; height: 78px;">
                <p class="text-muted">{{placeholder}} </p>
            </div>
        </Upload>
        <div v-if="verr[0]" class="form-text text-danger">{{verr[0]}}</div>
    </validation>
</template>

<script>

import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
    mixins: [singleErrorExtractorMixin],
    props: {
        value: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: "Click or drag files here to upload"
        },
        v: {
            type: Object,
            required: true
        },
        isLoading : {
            type: Boolean,
            default: false
        },
        verr : {
            type: Array,
            default: []
        }
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    },
    methods : {
        deleteImage : function(){
            this.data = ''
        },
        getHeaders (){
            return {
                'X-Requested-With' : 'XMLHttpRequest',
                'Authorization' : 'Bearer ' + localStorage.getItem("accessToken")
            };
        },
        handleSuccess (res, file) {
            if (!res.status.success) {
                this.showError(res.status.message,  res.status.errors.file);
                return;
            }
            this.data = res.data.url;
        },
        showError: function(title, text){
            this.$store.dispatch('pnotify/alert', {
                title: title,
                text: text,
                addclass: 'bg-warning border-warning'
            }, {root:true});
        },
        handleFormatError (file) {
            this.showError('Warning',  'File ' + file.name + ' is not a jpg or png.');
        },
        handleMaxSize (file) {
            this.showError('Warning',  'File ' + file.name + ' exceeded max size of 2MB.');
        },
        handleUploadError(error, file){
            this.showError('Warning',  'There was an error with your upload. Please try again. ');
        },
        getUploadPath () {
            return this.getApiUrl() + "/admin/categories/image";
        },
    }
};
</script>